import { AwsUi } from '../../../core/runtime/src';
import LegacyClassBuilder from '../../../core/utils/src/class-builders/legacy';
export var ColumnLayout = AwsUi.__addComponent('awsui-column-layout', {
    releaseStatus: 'stable',
    properties: {
        // The number of columns to be displayed by the layout.
        // Valid values are any integer between 1 and 4, the default is 1.
        columns: {
            type: 'integer',
            valid: [1, 2, 3, 4],
            defaultValue: 1
        },
        // Set it to
        // - `'none'` if you don't want borders between cells (default)
        // - `'vertical'` if you want only vertical borders
        // - `'horizontal'` if you want only horizontal borders
        // - `'all'` if you want both horizontal and vertical borders
        //
        // This property will be ignored if you set `variant` property to `'text-grid'`
        borders: {
            type: 'string',
            valid: ['none', 'vertical', 'horizontal', 'all'],
            defaultValue: 'none'
        },
        // Set it to `'text-grid'` when columns contain text. For example:
        // - for [key/value pairs](/system/structures/key_value_pairs/) in [resource details pages](/system/flows/details/)
        // - for blocks of content in a [service homepage](/system/flows/service_homepage/).
        //
        // If set to `'text-grid'`
        // - `borders` property will be ignored
        // - `awsui-util-no-gutters` CSS class on the component element will not have any effect.
        variant: {
            type: 'string',
            valid: ['default', 'text-grid'],
            defaultValue: 'default'
        }
    },
    regions: {
        // The column layout will be applied to the direct children of the element marked with the
        // attribute `data-awsui-column-layout-root="true"` inside this region.
        content: {
            isDefault: true
        }
    },
    render: function (m, h) {
        var borders = this.borders;
        var cb = new LegacyClassBuilder(this);
        var textGridVariant = this.variant === 'text-grid';
        var shouldHaveVerticalBorders = !textGridVariant && (borders === 'vertical' || borders === 'all');
        var shouldHaveHorizontalBorders = !textGridVariant && (borders === 'horizontal' || borders === 'all');
        cb.addClass('awsui-column-layout-columns-multiple', this.columns > 1)
            .addPropertyValueClass('columns')
            .addPropertyValueClass('variant')
            .addComponentClass('vertical-borders', shouldHaveVerticalBorders)
            .addComponentClass('horizontal-borders', shouldHaveHorizontalBorders);
        return h.region('content', 'div', { className: cb.toClassName() });
    }
});
//# sourceMappingURL=index.js.map